import { createI18n } from 'vue-i18n';
import en from './en';
import zhCN from './zh-CN';

const STORAGE_KEY = 'app-locale';

const messages = {
  'en': en,
  'zh-CN': zhCN,
};

function normalizeLocale(locale: string): string {
  const l = String(locale || '').trim();
  const lower = l.toLowerCase().replace('_', '-');

  if (lower.startsWith('zh'))
    return 'zh-CN';
  if (lower.startsWith('en'))
    return 'en';

  return 'en';
}

function getInitialLocale(): string {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved)
    return normalizeLocale(saved);

  const browser = navigator.language || 'zh-CN';
  return normalizeLocale(browser);
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: 'en',
  messages,
});

export function setLocale(locale: string) {
  const normalized = normalizeLocale(locale);
  i18n.global.locale.value = normalized;
  localStorage.setItem(STORAGE_KEY, normalized);
}

export type AppLocale = keyof typeof messages;
